/** @module root/components/accreditation/document */

import * as STATES                  from './tasks.states';
import { IDS }                      from './tasks-action-id.constants';
import { accTasksDetails }          from './details/details.component';
import { accTasks }                 from './list/tasks.component';
import { accTasksGrid }             from './list/tasks-grid.component';

export const TASKS_MODULE = angular.module(
    'migration.accreditation.tasks',
    []
).config(['$uiRouterProvider', ({ stateRegistry }) => {
        Object.values({
            ...STATES,
        }).map(state => stateRegistry.register(state));
    }]
).component({
    accTasksDetails,

    accTasks,
    accTasksGrid,

}).run(['$templateCache', ({ put }) => {
    put(IDS.app_accreditation_tasks_list,     '<acc-tasks></acc-tasks>');
    put(IDS.app_accreditation_tasks_details,  '<acc-tasks-details></acc-tasks-details>');
    put('./tasks-grid-filter.html', require('./list/tasks-grid-filter.html'));
    put('./tasks-link-dialog.html', require('./list/tasks-link-dialog.html'));
}]);
